import { action } from 'typesafe-actions';

// Types
import { TollTypes, TollInterface } from './types';

// List Tolls
export const listTollsRequest = (payload: {
  body?: object;
  filtering?: boolean;
}) => action(TollTypes.LIST_TOLLS_REQUEST, payload);

export const listTollsSuccess = (payload: {
  tollsList: TollInterface[];
  totalCount: number;
}) => action(TollTypes.LIST_TOLLS_SUCCESS, payload);

export const listTollsFailure = () => action(TollTypes.LIST_TOLLS_FAILURE);

// Get Toll
export const getTollRequest = (payload: object) =>
  action(TollTypes.GET_TOLL_REQUEST, payload);

export const getTollSuccess = (payload: { tollData: TollInterface }) =>
  action(TollTypes.GET_TOLL_SUCCESS, payload);

export const getTollFailure = () => action(TollTypes.GET_TOLL_FAILURE);

// Filter Tolls
export const filterTollsRequest = (payload: object) =>
  action(TollTypes.FILTER_TOLLS_REQUEST, payload);

export const filterTollsSuccess = (payload: {
  tollsList: TollInterface[];
  totalCount: number;
}) => action(TollTypes.FILTER_TOLLS_SUCCESS, payload);

export const filterTollsFailure = () => action(TollTypes.FILTER_TOLLS_FAILURE);

// Create Toll
export const createTollRequest = (payload: object) =>
  action(TollTypes.CREATE_TOLL_REQUEST, payload);

export const createTollSuccess = (payload: { tollData: TollInterface }) =>
  action(TollTypes.CREATE_TOLL_SUCCESS, payload);

export const createTollFailure = () => action(TollTypes.CREATE_TOLL_FAILURE);

// Update Toll
export const updateTollRequest = (payload: object) =>
  action(TollTypes.UPDATE_TOLL_REQUEST, payload);

export const updateTollSuccess = (payload: { tollData: TollInterface }) =>
  action(TollTypes.UPDATE_TOLL_SUCCESS, payload);

export const updateTollFailure = () => action(TollTypes.UPDATE_TOLL_FAILURE);

// Delete Toll
export const deleteTollRequest = (payload: object) =>
  action(TollTypes.DELETE_TOLL_REQUEST, payload);

export const deleteTollSuccess = () => action(TollTypes.DELETE_TOLL_SUCCESS);

export const deleteTollFailure = () => action(TollTypes.DELETE_TOLL_FAILURE);
